export const SETTINGS = 'SETTINGS';
export const API_DATETIME_FORMAT = `yyyy-MM-dd'T'HH:mm:ss`;
export const APP_DATE_FORMAT = `dd MMMM yyyy`;
export const APP_DATETIME_FORMAT = `HH:mm dd MMMM yyyy`;
export const APP_TIME_FORMAT = 'hh:mm a';
export const RETURN_URL = 'RETURN_URL';

export const Logs = {
  ENABLE_LIFE_CYCLE_LOGS: false,
  ENABLE_BACK_NAVIGATION_LOGS: false,
  ENABLE_AUTH_FLOW_LOGS: false,
  ENABLE_IDENTITY_SERVER_LOGS: false,
  ENABLE_DEEPLINK_LOGS: false,
};

export enum Language {
  en = 0, // English   ltr
  ar = 1, // Arabic    rtl
}
export const defaultLanguage: Language = Language.ar;
export const supportedLanguages: string[] = []; // contains codes of the supported languages (e.g. 'en', 'ar')
for (const l in Language) {
  // eslint-disable-next-line no-prototype-builtins
  if (Language.hasOwnProperty(l) && /^\d+$/.test(l)) {
    // discard the string keys of the enum
    supportedLanguages[l] = Language[l];
  }
}
export enum VersionStatus {
  NoUpdate = 0,
  UpdateRequired = 1,
  UpdateRecommended = 2,
}
export enum NgEvent {
  OnInit,
  OnDestroy,
  AfterContentInit,
  AfterContentChecked,
  AfterViewInit,
  AfterViewChecked,
}
